import Logger from '/@/modules/core/app/helpers/Logger';

export const StaticOptionPlugin = {
  install(app) {
    app.mixin({
      beforeCreate() {
        const { static: staticOption } = this.$options;
        if (staticOption && typeof staticOption === 'object') {
          Object.assign(this, staticOption);
        } else if (staticOption) {
          Logger.log('Expected option static to be only an object', Logger.LEVEL_ERROR);
        }
      }
    });

    app.config.optionMergeStrategies.static = (toVal, fromVal) => {
      return {
        ...toVal,
        ...fromVal
      };
    };
  }
};
